import axios from 'axios';
import {backendHost} from '../../config';

export const postAuthorization = (params) => {
    return axios.post(`${backendHost}/api/client/auth/authorization`, params);
};